import { render, staticRenderFns } from "./PopupClose.vue?vue&type=template&id=e054100e&scoped=true&"
var script = {}
import style0 from "./PopupClose.vue?vue&type=style&index=0&id=e054100e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e054100e",
  null
  
)

export default component.exports